import { createSlice } from '@reduxjs/toolkit';

const feedSlice = createSlice({
  name: 'feed',
  initialState: {
    scrollPositions: {
      desktop: 0,
      mobile: 0,
      desktopCompanions: 0,
      mobileCompanions: 0,
    },
    feedPosts: {
      desktop: [],
      mobile: [],
      desktopCompanions: [],
      mobileCompanions: [],
    },
    nextPages: {
      desktop: null,
      mobile: null,
      desktopCompanions: null,
      mobileCompanions: null,
    },
  },
  reducers: {
    saveScrollPosition: (state, action) => {
      const { platform, position } = action.payload;
      state.scrollPositions[platform] = position;
    },
    saveFeedState: (state, action) => {
      const { platform, position, posts, nextPage } = action.payload;
      state.scrollPositions[platform] = position;
      state.feedPosts[platform] = posts;
      state.nextPages[platform] = nextPage ?? null;
    },
    clearFeedState: (state, action) => {
      const { platform } = action.payload;
      state.scrollPositions[platform] = 0;
      state.feedPosts[platform] = [];
      state.nextPages[platform] = null;
    },
  },
});

export const { saveScrollPosition, saveFeedState, clearFeedState } = feedSlice.actions;
export default feedSlice.reducer;
